module.exports = __webpack_public_path__ + "static/media/Icon-material-bookmark.f76f037f.svg";